const RelatedModel = require('./related_model')
const log = require('log').create('user', 'testimonial') // eslint-disable-line

const Testimonial = RelatedModel.extend({

    defaults: {
        quote: '',
        attribution: '',
    },

    validators: {
        'quote'(value, attrs) {
            if (! value) return 'Please enter a quote.'
        },
        'attribution'(value, attrs) {
            if (! value) return 'Please enter an attribution.'
        },
    },

})

module.exports = Testimonial
